import { IconPlusCircle } from 'assets/images'
import { Button, EventMonitoring } from 'components'
import { useFormikContext } from 'formik'
import moment from 'moment'
import { useState } from 'react'
import { If } from 'react-extras'
import {
  Monitoring,
  MonitoringExamination,
  MonitoringState,
  Report
} from 'store/ducks'
import styled from 'styled-components'
import { v4 as uuid } from 'uuid'
import MonitoringForm from '../../../../../containers/MonitoringForm'
import FormTitle from '../FormTitle'
import { FlexRow, RowItem } from '../styled'

const IconPlusCircleStyled = styled(IconPlusCircle)`
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  margin-left: 10px !important;
  transform: none !important;
`

const SurveillanceSection = () => {
  const [open, setOpen] = useState<boolean>(false)
  const {
    values: { investigationAndMonitoring }
  } = useFormikContext<Report>()

  const [currentMonitoring, setCurrentMonitoring] = useState<Monitoring>(
    {} as unknown as Monitoring
  )

  const startNewMonitoring = () => {
    const newMonitoring: Monitoring = {
      id: uuid(),
      breathFrequency: '',
      monitoringHour: moment().toDate(),
      state: '' as MonitoringState,
      conductedExamination: '' as MonitoringExamination,
      time: moment().toDate(),
      glasgowScore: '',
      pulse: ''
    }

    setCurrentMonitoring(newMonitoring)
    setOpen(true)
  }

  const saveMonitoring = () => {
    const isUpdate = investigationAndMonitoring.monitoring.find(
      m => m.id === currentMonitoring.id
    )

    if (isUpdate) {
      for (let mon of investigationAndMonitoring.monitoring) {
        if (mon.id === currentMonitoring.id) {
          mon = {
            ...currentMonitoring
          }
        }
      }
    } else {
      investigationAndMonitoring?.monitoring.push(currentMonitoring)
    }

    setOpen(false)
  }

  const openMonitoring = (monitoring: Monitoring) => {
    setCurrentMonitoring(monitoring)
    setOpen(true)
  }

  return (
    <>
      <FormTitle title="monitoring" />
      <FlexRow>
        <RowItem>
          {investigationAndMonitoring.monitoring &&
            investigationAndMonitoring.monitoring.map((monitoring, index) => (
              <EventMonitoring
                key={index}
                monitoring={monitoring}
                openMonitoring={openMonitoring}
              />
            ))}
        </RowItem>
      </FlexRow>
      <If condition={!open}>
        <FlexRow>
          <RowItem>
            <Button
              style={{
                maxWidth: 'max-content',
                marginTop: 20,
                display: 'flex',
                alignItems: 'center'
              }}
              icon={
                <IconPlusCircleStyled width={25} height={25} fill="#0072BB" />
              }
              variant="default"
              label="startNewMonitoring"
              onClick={startNewMonitoring}
              type="button"
            />
          </RowItem>
        </FlexRow>
      </If>
      <If condition={open && currentMonitoring ? true : false}>
        <MonitoringForm
          onChangeData={(_monitoring: Monitoring) => {
            setCurrentMonitoring(_monitoring)
          }}
          saveMonitoring={saveMonitoring}
          monitoring={currentMonitoring}
        />
      </If>
    </>
  )
}

export default SurveillanceSection
